import servicesUtils from "../../../utils/servicesUtils";
var deletePatientReminder = function deletePatientReminder(patientUid, reminderId) {
  return servicesUtils.deleteService("/patients/".concat(patientUid, "/reminder/").concat(reminderId, "/"));
};
export default deletePatientReminder;